import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowLastSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 4.414 6.586 8 3 11.586 4.414 13l5-5-5-5L3 4.414ZM13 3h-2v10h2V3Z"
    />
  </svg>
);
export default IconArrowLastSizeS;
